import { Fn_activeAxios } from "function/FnConfig";

/** ------------사업자번호 검증------------**/
interface ConnectionServiceProps {
  rootStore: any;
  shopCd: string;
  bizNo: string;
  token: string;
  name?: string;
}

export interface ConnectionServiceResponse {
  bizNo?: string;
  resultCode: string;
  resultMsg: string;
  data: string;
}

export async function getConnectionService({
  rootStore,
  shopCd,
  bizNo,
  token,
}: ConnectionServiceProps): Promise<ConnectionServiceResponse> {
  const api = Fn_activeAxios(rootStore);
  const response = await api.get(`/gate/okgo/validation/${shopCd}/${bizNo}`, {
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
  });

  return {
    data: response.data,
    bizNo: bizNo,
    resultCode: response.data.resultCode,
    resultMsg: response.data.resultMsg,
  };
}

/** ------------연동 매장 목록 조회------------**/
interface ShopList {
  agencyCode: number;
  shopName: string;
  mapped: boolean;
}
export async function getShopList({
  rootStore,
  shopCd,
  bizNo,
  token,
  name,
}: ConnectionServiceProps): Promise<ShopList[] | null> {
  const api = Fn_activeAxios(rootStore);
  const response = await api.get(`/gate/${name}/${shopCd}/${bizNo}/shops`, {
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
  });

  if (name === "oltteaah") {
    return (
      response.data.data?.shops?.map((item: ShopList) => ({
        vendorId: item.agencyCode,
        vendorName: item.shopName,
        mapped: item.mapped,
      })) ?? []
    );
  }

  return response.data.data?.shops ?? [];
}

/** ------------매장 연동 요청------------**/
interface UpdateMappingPayload {
  bizNo: string;
  mappingAction: boolean;
  mappingCd: string;
  mappingType: string;
  shopCd: string;
  shopNm: string;
  posNo: string;
  telNo: string;
  contactPossibleTime: string;
}

export async function updateOrderMapping(
  rootStore: any,
  payload: UpdateMappingPayload
): Promise<{ resultCode: string }> {
  const { searchStore } = rootStore;

  const api = Fn_activeAxios(rootStore);

  const response = await api.put("/gate/okgo/orders/mappings", payload, {
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + searchStore.getToken },
  });

  return response.data;
}
